<template>
  <v-dialog
    v-if="currentUser.permissions.publish_photos === true"
    v-model="publishdialog"
    max-width="600"
    class="image-popup"
  >
    <template #activator="{ on }">
      <v-btn
        right
        :disabled="itemsCount <= 0"
        color="secondary"
        class="mr-2"
        v-on="on"
      >
        <span class="d-none d-md-flex">Publish</span>
        <v-icon right>mdi-send-circle-outline</v-icon>
      </v-btn>
    </template>
    <v-btn
      color="secondary"
      icon
      class="popup-close"
      @click="publishdialog = false"
    >
      <v-icon>mdi-close-circle-outline</v-icon>
    </v-btn>
    <v-card>
      <div class="diaog-inner pa-10 grey lighten-5">
        <v-card-title>Publish selected images?</v-card-title>

        <v-card-text>
          <v-form>
            <v-btn color="primary" class="mt-2" @click="doPublishSelected(true)"
              >Publish</v-btn
            >
            <v-btn
              color="primary"
              class="mt-2"
              @click="doPublishSelected(false)"
              >Unpublish</v-btn
            >
          </v-form>
        </v-card-text>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters } from "vuex";
import ApiService from "@/common/api.service";
import toast from "@/services/toast";
import { PHOTO_UPDATE_PUBLISH_STATE } from "@/store/actions.type";

export default {
  name: "PublishSelected",
  data: () => ({
    publishdialog: false,
  }),
  computed: {
    itemsCount() {
      return this.selectedImagesIds.length;
    },
    ...mapGetters(["selectedImagesIds", "activeExpClient", "currentUser"]),
  },
  methods: {
    async doPublishSelected(publishChoice) {
      return ApiService.post("publish-photos", {
        client_id: this.activeExpClient.id,
        published_to_client: publishChoice,
        photo_ids: this.selectedImagesIds,
      })
        .then((resp) => {
          toast.success(resp.data.message);
          this.publishdialog = false;
          this.$store.dispatch(PHOTO_UPDATE_PUBLISH_STATE, {
            ids: this.selectedImagesIds,
            publishChoice,
          });
        })
        .catch((err) => {
          console.log(err);
          this.publishdialog = false;
          if (typeof err.response.data.message !== "undefined") {
            toast.error(err.response.data.message);
          } else {
            toast.error("Something went wrong");
          }
        });
    },
  },
};
</script>
